/*
 * Merch Control - scroll-reveal system.
 * Ported from the approved Astro wireframe (Base.astro, see docs/round1/wireframe-spec.md
 * section 5.2): additive-only, IntersectionObserver-driven, with a scroll/resize/hashchange
 * sweep() safety net so an anchor-jump never leaves anything stuck invisible.
 * prefers-reduced-motion short-circuits everything to immediately-visible.
 *
 * Ownership note: this build stage owns templates/index.json + NEW mc- sections only, not
 * Horizon's shared generic section/group/text/button templates. So elements inside those
 * shared, non-owned sections are revealed as ONE unit per section (their own Shopify section
 * wrapper, #shopify-section-<id>) to avoid reaching into markup this stage doesn't own.
 * Sections built as custom mc- markup (hero, offer cards) mark their own finer-grained
 * [data-mc-reveal] targets directly in their own liquid and are picked up the same way.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var sectionIds = ['work_teaser_mc', 'industries_mc', 'mc_process', 'proof_mc', 'faq_mc', 'cta_mc'];

  function onScreen(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
  }

  var armedEls = [];
  var observer = null;

  function arm(el) {
    el.classList.add('reveal');
    if (reduceMotion) {
      el.classList.add('in');
      return;
    }
    if (onScreen(el)) {
      el.classList.add('in');
      return;
    }
    el.classList.add('armed');
    armedEls.push(el);
    if (observer) observer.observe(el);
  }

  function sweep() {
    for (var i = 0; i < armedEls.length; i++) {
      var el = armedEls[i];
      if (!el.classList.contains('in') && onScreen(el)) {
        el.classList.add('in');
      }
    }
  }

  function collectTargets() {
    var targets = [];
    sectionIds.forEach(function (id) {
      var wrap = document.getElementById('shopify-section-' + id);
      if (wrap) targets.push(wrap);
    });
    document.querySelectorAll('[data-mc-reveal]').forEach(function (el) {
      targets.push(el);
    });
    return targets;
  }

  function init() {
    var targets = collectTargets();
    if (!targets.length) return;

    if (!reduceMotion && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
    }

    targets.forEach(arm);

    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        sweep();
        raf = null;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', sweep);
    window.addEventListener('hashchange', sweep);
    if (window.location.hash) sweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
